import { UserActionType, UserAction, UserState } from './types';

const initialState: UserState = {
  me: null,
  settings: null,
  clickAways: [],
  clickAwaysById: {},
  has2025Licenses: false,
  licenses: [],
  licensesById: {},
  isLoggedOut: false,
  isAuthenticated: false,
  isForbidden: false,
  isAuditor: false,
  error: null,
  tours: null,
  managedUser: false
};

const userReducer = (state: UserState = initialState, action: UserAction) => {
  switch (action.type) {
    case UserActionType.FETCH_ME_SUCCESS: {
      const { settings, licenses, clickAways, isAuditor, has2025Licenses, ...me } = action.data;

      return {
        ...state,
        me,
        has2025Licenses,
        settings,
        licenses,
        clickAways,
        isAuditor,
        isAuthenticated: true
      };
    }
    case UserActionType.SAVE_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.data
        }
      };
    case UserActionType.USER_LOGIN_STARTED:
      return {
        ...state
      };
    case UserActionType.LOGOUT_USER:
      return {
        ...state,
        isLoggedOut: true
      };
    case UserActionType.USER_ACTION_ERROR:
      return {
        ...state,
        error: action.data.err,
        isForbidden: action.data.isForbidden
      };
    case UserActionType.RESET_STATE:
      return {
        ...state,
        error: null
      };
    case UserActionType.REMOVE_TOUR_STEP: {
      const { tours } = state.settings as any;

      const foundTour = tours?.find(x => x.name === action.data.tourName);
      const otherTours = tours.filter(x => x.name !== action.data.tourName);
      const steps = foundTour.steps?.filter(x => x.name !== action.data.stepName);

      const nextState = {
        ...state,
        settings: {
          ...state.settings,
          tours: [...otherTours, { ...foundTour, steps }]
        }
      };

      return nextState;
    }
    case UserActionType.REMOVE_MULTIPLE_TOUR_STEPS: {
      const { tours } = state.settings as any;

      const foundTour = tours?.find(x => x.name === action.data.tourName);
      const otherTours = tours.filter(x => x.name !== action.data.tourName);
      const steps = foundTour.steps?.filter(x => !action.data.stepNames.includes(x.name));

      const nextState = {
        ...state,
        settings: {
          ...state.settings,
          tours: [...otherTours, { ...foundTour, steps }]
        }
      };

      return nextState;
    }
    case UserActionType.REMOVE_ALL_TOUR_STEPS: {
      const { tours } = state.settings as any;

      const foundTour = tours?.find(x => x.name === action.data.tourName);
      const otherTours = tours.filter(x => x.name !== action.data.tourName);

      const nextState = {
        ...state,
        settings: {
          ...state.settings,
          tours: [...otherTours, { ...foundTour, steps: [] }]
        }
      };

      return nextState;
    }
    case UserActionType.UPDATE_SETTING: {
      return {
        ...state,
        settings: {
          ...state.settings,
          [action.data.name]: action.data.value
        }
      };
    }
    default:
      return state;
  }
};

export default userReducer;
